import { bold as bold_1 } from './bold.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleBold } from 'roosterjs-editor-api';

const bold: RibbonButton = {
    key: 'bold',
    title: () => loc(bold_1),
    imageSrc: require('../svg/bold.svg'),
    shortcut: 'ctrl+B',
    buttonState: formatState =>
        formatState.isBold ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleBold(plugin.getEditor()),
};

export default bold;
